import { NgModule } from '@angular/core';
import { Dtn209Component } from './dtn209.component';



@NgModule({
  declarations: [Dtn209Component],
  imports: [
  ],
  exports: [Dtn209Component]
})
export class Dtn209Module { }
